'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const { Component } = React;
const Relay = require('react-relay/classic');
const { getUserId, cookieJarConstants, getEverLoggedIn } = require('dibs-cookie-jar');

const { constants: authConstants } = require('dibs-buyer-layout/src/utils/AuthModalLoader').default;
const getNetworkLayer = require('../../../global/relayClientNetworkLayer');
const { abExperiments } = require('dibs-buyer-layout/src/entries/index');

const MultiContactDealerModalRenderer = require('./MultiContactDealerModalRenderer');

let optimizelyVariant = 'control';
if (abExperiments.guidedContactDealer) {
    Promise.resolve(abExperiments.guidedContactDealer).then(res => {
        optimizelyVariant = res;
    });
}

if (abExperiments.makeOfferCheckbox) {
    Promise.resolve(abExperiments.makeOfferCheckbox).then(res => {
        optimizelyVariant = res;
    });
}

function getNewEnvironment() {
    const e = new Relay.Environment();
    e.injectNetworkLayer(getNetworkLayer());
    return e;
}

class ContactDealerRenderer extends Component {
    startAuth({ callback, options }) {
        const { modalProps } = this.props;
        return modalProps
            .authProcess({
                email: options.emailValue,
                dealerName: options.dealerName,
                action: options.userExists ? authConstants.LOGIN : authConstants.REGISTER,
            })
            .then(userJSON => {
                this.forceUpdate(); // set new environment user token
                callback({
                    authAction: userJSON.newUser ? authConstants.REGISTER : authConstants.LOGIN,
                });
            });
    }

    render() {
        const { modalProps } = this.props;
        const {
            PreContactDealer,
            Confirmation,
            ContactDealer,
            ContactDealerModal,
            MultiRequestContactDealerModal,
            GuidedCopy,
            LowBall,
            MakeOffer,
            ModalWrapper,
        } = modalProps.modalComponents;
        const { itemPk, dealerPk, currentStep, isVerifiedTrade, isRequestMoreImages } = modalProps;
        const showMultiRequestModal =
            !isRequestMoreImages && currentStep === 'contactDealer' && isVerifiedTrade;

        const userId = getUserId(document.cookie, cookieJarConstants.MASQUERADE_BUYER);

        // used for A/B test GA tracking (MCPERSON-2909 & MCPERSON-2910)
        const userHasEverLoggedIn = !!getEverLoggedIn(document.cookie);

        const queryConfig = {
            queries: {
                viewer: (component, params) => Relay.QL`
                    query {
                        viewer {
                            ${component.getFragment('viewer', params)}
                        }
                    }
                `,
            },
            name: 'ContactDealerModalRoute',
            params: {
                shouldFetchItem: !!itemPk,
                shouldFetchImage: optimizelyVariant === 'contactDealerSidebar',
                hasUserId: !!userId,
                shouldFetchUser: !!userId,
                shouldFetchBuyerItemConv: !!itemPk && !!userId,
                shouldFetchUserAndItem: !!itemPk && !!userId,
                itemId: itemPk || null,
                itemIds: [itemPk],
                sellerId: dealerPk,
                userId,
                userIds: [userId],
            },
        };

        const forceEnvironmentUpdate = variablesToSet => {
            // manually set variables in the queryConfig because relay.setVariables
            // causes a re-render, and we're already forcing a re-render with forceUpdate
            queryConfig.params = Object.assign({}, queryConfig.params, variablesToSet);
            this.forceUpdate();
        };

        if (showMultiRequestModal) {
            return (
                <MultiRequestContactDealerModal isOpen>
                    <MultiContactDealerModalRenderer
                        queryConfig={queryConfig}
                        modalProps={modalProps}
                        getNewEnvironment={getNewEnvironment}
                        forceEnvironmentUpdate={forceEnvironmentUpdate}
                    />
                </MultiRequestContactDealerModal>
            );
        }

        return (
            <Relay.Renderer
                Container={ContactDealerModal}
                environment={getNewEnvironment()}
                queryConfig={queryConfig}
                render={({ done, error, props }) => {
                    if (done && props) {
                        const contactDealerProps = Object.assign({}, modalProps, props, {
                            forceEnvironmentUpdate,
                            userHasEverLoggedIn,
                            optimizelyVariant,
                        });

                        return (
                            <ContactDealerModal {...contactDealerProps}>
                                <GuidedCopy />
                                <ContactDealer />
                                <Confirmation />
                                <MakeOffer isContactDealer />
                                <LowBall />
                                <PreContactDealer />
                            </ContactDealerModal>
                        );
                    }

                    return <ModalWrapper openOnRender isError={!!error} isLoading={!done} />;
                }}
            />
        );
    }
}

ContactDealerRenderer.propTypes = {
    queryProps: PropTypes.object,
    modalProps: PropTypes.object,
};

module.exports = ContactDealerRenderer;



// WEBPACK FOOTER //
// ./assets/js/contact/dealer/components/ContactDealerRenderer.jsx